/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const CloneStampIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Clone Stamp',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M20.647 21.62a29.989 29.989 0 0 1-.771-5.178 9.971 9.971 0 0 1 .612-2.945 5.755 5.755 0 0 0 3.631-5.748 6.111 6.111 0 1 0-12.222 0 5.748 5.748 0 0 0 3.611 5.744 10.467 10.467 0 0 1 .622 2.949 31.39 31.39 0 0 1-.777 5.179c-2.923.148-10 1.767-12.48 2.351A1.146 1.146 0 0 0 2 25.1v3.729A1.153 1.153 0 0 0 3.146 30h29.711A1.154 1.154 0 0 0 34 28.836V25.1a1.146 1.146 0 0 0-.873-1.131c-2.476-.581-9.554-2.2-12.48-2.349Z"
    />
    <rect x="4" y="32" width="28" height="2" rx=".5" />
  </svg>`;
};
